import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import CommissionsWalletCardList from './CommissionsWalletCardList';
import WalletCryptoFarmInfo from './WalletCryptoFarmInfo';
import WalletProp, { WALLET_TYPE } from '../../proptype/walletProp';
import ConfigsContext from '../../../../contextProviders/ConfigsContext';

export default function CommissionsWalletPicker(props) {
  const {
    wallets,
    activeWalletIndex,
    onSelectWallet,
    walletEnabled,
    onSeeTransactions,
    onWithdrawal,
    onExchange,
  } = props;

  const { organization } = useContext(ConfigsContext);
  const { f2pool } = organization?.services || {};
  const isF2PoolEnabled = f2pool?.enabled;

  if (!walletEnabled || wallets.length === 0) {
    return <div style={{ height: '60px' }} />;
  }

  const activeWallet = wallets[activeWalletIndex];
  const isCrypto = activeWallet?.type === WALLET_TYPE.CRYPTO;
  const showFarmInfo = isF2PoolEnabled && isCrypto;

  return (
    <div className="commissions-wallet-picker-container">
      <CommissionsWalletCardList
        wallets={wallets}
        activeWalletIndex={activeWalletIndex}
        onSelectWallet={onSelectWallet}
        onSeeTransactions={onSeeTransactions}
        onWithdrawal={onWithdrawal}
        onExchange={onExchange}
      />
      {showFarmInfo && (
        <WalletCryptoFarmInfo wallet={activeWallet} />
      )}
    </div>
  );
}

CommissionsWalletPicker.propTypes = {
  walletEnabled: PropTypes.bool.isRequired,
  wallets: PropTypes.arrayOf(PropTypes.shape(WalletProp.propType).isRequired)
    .isRequired,
  activeWalletIndex: PropTypes.number.isRequired,
  onSelectWallet: PropTypes.func.isRequired,
  onSeeTransactions: PropTypes.func.isRequired,
  onWithdrawal: PropTypes.func.isRequired,
  onExchange: PropTypes.func.isRequired,
};
